
import * as Constants from '../../../../common/constants';
import {apis} from "../../../../api/apis";
import base64 from "base-64";

export const gatherFiles = (filesState) => {
    let gatheredFiles = [];
    //validate and gather uploaded files
    //gather font files
    if (filesState && filesState.fonts) {
        for (let i = 0; i < filesState.fonts.length; i++) {
            if (/.*\.(woff|otf|ttf)$/i.exec(filesState.fonts[i].name) === null) {
                alert(`${filesState.fonts[i].name} is not a valid font file.`);
                return false;
            } else {
                gatheredFiles.push(filesState.fonts[i]);
            }
        }
    }
    //gather link filesState
    if (filesState && filesState.links) {
        for (let i = 0; i < filesState.links.length; i++) {
            console.log("FileType: ", filesState.links[i].name, "Regex: ", /.*\.(jpg|jpeg|png|bmp|gif|svg|pdf|psd|tiff|tif)$/i.exec(filesState.links[i].name));
            if (/.*\.(jpg|jpeg|png|bmp|gif|svg|pdf|psd|tiff|tif)$/i.exec(filesState.links[i].name) === null) {
                alert(`${filesState.links[i].name} is not a valid link file.`);
                return false;
            } else {
                gatheredFiles.push(filesState.links[i]);
            }
        }
    }
    //gather idml
    if (filesState && filesState.idml) {
        for (let i = 0; i < filesState.idml.length; i++) {
            if (/.*\.idml$/i.exec(filesState.idml[i].name) === null) {
                alert(`${filesState.idml[i].name} is not a valid idml file.`);
                return false;
            } else {
                gatheredFiles.push(filesState.idml[i]);
            }
        }
    } else {
        alert("Please upload an idml file.");
        return false;
    }
    console.log("gatheredFiles", gatheredFiles);
    return gatheredFiles;
};

export const createTemplateLocation = async (info, ccApis, userUpload = false) => {

    let saveInfo = {"info": {
            ...info
        },
        "userUpload" : userUpload
    };

    const tempLoc = await ccApis.createTemplatePath(saveInfo);
    //if template path couldn't be created, stop the application
    if (!tempLoc){
        alert("There was a problem creating the id for the new template!");
        return false;
    }
    return tempLoc;
};

export const clearTemplateFiles = async (templateId, host) => {

    let headers = {
        'template_id': templateId,
        "connection": "keep-alive",
        "authorization": `Basic ${base64.encode(`${Constants.CC_API_USERNAME}:${Constants.CC_API_PASSWORD}`)}`
    };

    const clear = await fetch(`${host}${Constants.CC_TEMPLATE_CLEAR_FILES_URL}`, {
        headers: headers,
        method: "DELETE"
    }).catch( (e) => (
        alert(`Template Couldn't Be Cleared! ${e}`)
    ));
    return clear;
}

export const uploadFilesToCC = async (gatheredFiles, templateLocation, host) =>{
    //remove the content of the given template location(if it exists)
    await clearTemplateFiles(templateLocation._id, host);

    const systemConstants = await apis.getSystemConstants();
    const ccHosts = systemConstants.DS_SERVER_URLS_WITH_VERSIONS;

    for (let i = 0; i < gatheredFiles.length; i++) {
        let headers = {
            'filename': gatheredFiles[i].name,
            'templatepath': templateLocation.filePath.substring(0, templateLocation.filePath.lastIndexOf('/')),
            'id': templateLocation._id,
            "connection": "keep-alive",
            "authorization": `Basic ${base64.encode(`${Constants.CC_API_USERNAME}:${Constants.CC_API_PASSWORD}`)}`
        };

        let formData = new FormData();
        formData.append('file', gatheredFiles[i]);

        const file = await fetch(`${host}${Constants.CC_TEMPLATE_UPLOAD_FILES_URL}`, {
            headers: headers,
            body: formData,
            method: "POST"
        }).catch( (e) => (
            alert(`File couldn't be sent! ${e}`)
        ));

        // stop execution if one file couldn't be uploaded
        if (!file) {
            alert( `There was a problem uploading ${gatheredFiles[i].name}` );
            return;
        }

        // apply font-specific processing
        const fileExtension = gatheredFiles[i].name.split(".").pop().toLowerCase();
        const fileIsFont = ["woff", "otf", "ttf"].includes(fileExtension);
        if (fileIsFont) {

            // check return status to see if the font was not uploaded
            switch (file.status)
            {
                case 513:
                    return alert( `The font file ${gatheredFiles[i].name} already exist and is not the same size. File not uploaded.` );
                case 514:
                    return alert( `The font file ${gatheredFiles[i].name} already exist and is the same size. File not uploaded.` );
                case 515:
                    return alert( `The font file ${gatheredFiles[i].name} is invalid. File not uploaded.` );
            }

            // if successful and the uploaded file is a font file, then upload to all other CC servers - the font is
            // already available to these servers, but CC caching prevents their use until an IIS Reset is run - sending
            // the font to each server has the same effect - this will return a 514 status, but that's OK - the font is
            // not saved again, but it still triggers the font cache refresh
            if (ccHosts?.length) {
                let fileExtension = gatheredFiles[i].name.split(".").pop().toLowerCase();
                if (["woff", "otf", "ttf"].includes(fileExtension)) {

                    for (const ccHost of ccHosts) {
                        if (ccHost.host === host) continue;

                        await fetch(`${ccHost.host}${Constants.CC_TEMPLATE_UPLOAD_FILES_URL}`, {
                            headers: headers,
                            body: formData,
                            method: "POST"
                        }).catch(e => {
                            // don't issue an alert to the end user - if the font doesn't post and an issue arises, we will
                            // receive an error notice from Sentry upon use
                            console.log(`File couldn't be sent to alternate server at ${ccHost.host}!`, e);
                        });

                    };

                }
            }

        }

    }
};